/*******************************************
 * 教研组项目公共基础方法封装
 * @version 1.0
 * @anthor : duxinli
 * @date: 2018-07-05
 *********************************************/
import axiosSpecial from 'axios'
import JY_CONFIG from './config'
import { Message, MessageBox, Loading} from 'element-ui'
import utils from './utils'
const xesBaseFn = {
    /**
     * 设置cookie方法
     * @param   {string}  key  cookie键值
     * @param   {string}  value  cookie对应的键值内容
     * @param   {Boolean}  type  cookie设置是否跨域
     */
    setCookie (key, value, type) {
        var exdate = new Date(),
            expiredays = 365;
        exdate.setDate(exdate.getDate() + expiredays);
        //判断是否需要跨域存储
        if (type) {
            document.cookie = key + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/;domain=xesv5.com";
        } else {
            document.cookie = key + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
        }
    },
    /**
     * 获取cookie方法
     * @param   {string}  name  cookie键值
     * @return  {*}  返回cookie值
     */
    getCookie (name) {
      var strcookie = document.cookie;//获取cookie字符串
      var arrcookie = strcookie.split("; ");//分割
      //遍历匹配
      for ( var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] === name){
          return unescape(arr[1]);
        }
      }
      return "";
    },
    /**
     * 删除cookie方法
     * @param   {string}   key  cookie键值
     * @param  {Boolean}  type  cookie设置是否跨域
     */
    delCookie (key, type) {
      var _this = this
      var del = new Promise(function(resolve, reject) {
          var exdate = new Date(),
              expiredays = -1;
          exdate.setDate(exdate.getDate() + expiredays);
          var value = _this.getCookie(key);
          if (value) {
              //判断是否跨域
              if (type) {
                  document.cookie = key + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/;domain=xesv5.com";
              } else {
                  document.cookie = key + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
              }
          }
          resolve()
      })
      return del
    },
    /**
    * 解析字符串，将url?后的key=main_choose_grade_id&value=3这样的字符串转换成一个带有=前键值的对象方法
    * param     {String} getStr   字符串
    * @return   {Object}          返回str转换后的对象
    */
    parseStr(getStr){
        var changeObject = {}, arr = [];
        var str = getStr.split('?')[1];
        if (!str) {
            return false;
        }
        //将字符串以&为分割点转换成数组
        arr = str.split("&");
        //循环字符串转换为了对应键值的对象,字符串必须是ey=main_choose_grade_id&value=3格式
        for(var i = 0; i < arr.length; i ++) {
          changeObject[arr[i].split("=")[0].toLowerCase()] = (arr[i].split("="))[1];
        }
        return changeObject;
      },
      /**
       * 创建loading
       * @return {Object} 返回方法对象
       */
      createLoginVerifyLoading () {
        let result = {}
        // 定义loading显示缓冲
        result.waitTimer = null
        // 设置缓冲时间
        result.waitTime = 500
        // 显示loading
        result.show = () => {
          // 定义1s之后显示loading，避免闪现
          clearTimeout(result.waitTimer)
          result.waitTimer = null
          result.waitTimer = setTimeout(() => {
            // 创建loading遮罩元素
            result.loadingEle = Loading.service({
              lock: true,
              text: 'Loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            result.waitTimer = null
          }, result.waitTime)
        }

        // 隐藏loading
        result.hide = () => {
          if (result.waitTimer) {
            clearTimeout(result.waitTimer)
            result.waitTimer = null
            return
          }
          result.loadingEle.close()
        }
        return result
      },
      /**
       * vue-router 注册全局前置守卫 为了检查是否存在token验证, 后期修改为验证应用中的每个url是否登录，未登录返回tnt登录页
       * @param  {Object} router  vue实例化Router
       * @param  {Object} from   当前导航正要离开的路由
       */
      isTokenRouter (router) {
        let _t = this
        const PROTOCOL = location.protocol || 'https:'
        router.beforeEach((to, from, next) => {
          // 获取域名，tnt门户平台不校验是否登录, 并且Admin/getMenu路由不验证
          let projectName = jiaoyan_project.name
          // 获取token
          let token = _t.getCookie('token')
          if (projectName != 'tikuProduction' && projectName != 'thinkSchool'){
            // 判断是否登录
            if (projectName != 'jiaoyanmenhu' && to.path != '/Admin/getMenu'){
              if (token) {
                if (projectName == 'magicCube' && to.name == 'preview' && window.location.search) {
                  next()
                  return
                }
                let axios = axiosSpecial.create()
                // 请求拦截器
                axios.interceptors.request.use((config) => {
                    if (config.method === 'post') {
                        config.data = qs.stringify(config.data);
                    }
                    return config;
                }, (error) => {
                    Message.error({
                        message: '加载超时'
                    })
                })
                // 响应拦截器
                axios.interceptors.response.use((res) => {
                   if (res.data.status === 100 || res.data.status === 1001) {
                        return res.data;
                    }
                    return Promise.reject(res.data);
                }, (error) => {
                    let errorMsg = '网络异常，请刷新重试！'
                    error.data = errorMsg
                   return Promise.reject(error)
                })
                // 添加loading优化
                const createLoading = _t.createLoginVerifyLoading()
                createLoading.show()
                let params = {
                  token: token
                }
                let headers = {}
                if(JY_CONFIG.jytoken.includes(projectName)){
                  params = {}
                  headers['jytoken'] = token
                }
                const requestUrl = process.env.NODE_ENV === 'development'
                  ? '/login/checkLogin'
                  : `${PROTOCOL}//tntapi.xesv5.com/login/checkLogin`
                axios.get(requestUrl, {
                  params,
                  headers
                })
                .then((res) => {
                  // 请求成功关闭loading
                  createLoading.hide()
                  // 判断是否登录  100已登录，1001未登录
                  let isLogin = res.status
                  if (isLogin === 1001) {
                    // 未登录跳转回门户
                    MessageBox.alert('未登录，请先进入门户平台登录！', '提示', {
                      confirmButtonText: '确定',
                      callback: action => {
                        let newUrl = ''
                        if (Number(utils.getParams('school_id')) === 1) { // 盈利
                          newUrl = `${PROTOCOL}//tnt.saasz.vdyoo.com/#/`
                        }
                        if (Number(utils.getParams('school_id')) === 100) { // 非盈利
                          newUrl = `${PROTOCOL}//tntxk.saasz.vdyoo.com/#/`
                        }
                        window.location.href = utils.getParams('domain') || newUrl
                        // window.location.href = `${PROTOCOL}//tnt.xesv5.com`
                      }
                    })
                  } else if (isLogin === 100) {
                    // 登录
                    next()
                  }
                })
                .catch((err) => {
                  // 请求失败关闭loading
                  createLoading.hide()
                  Message.error({
                      message: err.data
                  })
                })
              } else {
                // 魔方系统大纲预览不校验token
                const questionMarkIndex = window.location.href.indexOf('?');
                if (projectName == 'magicCube' && to.name == 'preview' && questionMarkIndex !== -1) {
                  next()
                } else {
                  // 未登录跳转回门户
                  MessageBox.alert('未登录，请先进入门户平台登录！', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      let newUrl = ''
                      if (Number(utils.getParams('school_id')) === 1) { // 盈利
                        newUrl = `${PROTOCOL}//tnt.saasz.vdyoo.com/#/`
                      }
                      if (Number(utils.getParams('school_id')) === 100) { // 非盈利
                        newUrl = `${PROTOCOL}//tntxk.saasz.vdyoo.com/#/`
                      }
                      window.location.href = utils.getParams('domain') || newUrl
                      // window.location.href = `${PROTOCOL}//tnt.xesv5.com`
                    }
                  })
                }
              }
            } else {
              next()
            }
          } else {
            // 排除获取token验证的/Admin/getMenu以外的其他路由均需要验证token，如果token不存在则跳转到后台系统
            if (to.path != '/Admin/getMenu') {
                // 如果token不存在，验证不通过，跳转到后台
                if (!token) {
                  window.location.href = `${PROTOCOL}//admin.xesv5.com`
                } else {
                  next()
                }
            } else {
              next()
            }
          }
        })
      }
}

export default xesBaseFn



// WEBPACK FOOTER //
// ./common/assets/js/xes.base.js